import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import Image from "next/image";
import ImageUploader from "@/app/components/ui/ImageUploader";
import Input from "@/app/components/ui/Input";
import icons from "@/assets/icons";
import VoiceRecorder from "@/app/components/ui/VoiceRecorder";
import { imageUrl as ImageURL } from "@/utils/constants";
type ResponseInputProps = {
  children?: React.ReactNode;
  placeHolder: string;
  styleClass: string;
  inputValue?: string;
  handleInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  index: number;
  imageUrl?: string | undefined;
  handleImageChange?: (
    image: any,
    choiceIndex: number,
    answerIndex?: number
  ) => void;
  imageWidth?: string;
  imageHeight?: string;
  hasFile?: boolean;
  id: string;
  valueUpdated?: Function;
  tabIndex: number;
  questionInput?: boolean;
  maxLength?: number;
  setSentence?: Dispatch<SetStateAction<string>>;
  questionDirection?: string;
  hasAudio?: boolean;
  handleVoiceChange?: (
    voice: any,
    choiceIndex: number,
    answerIndex?: number
  ) => void;
  inputVoice?: string;
  onImageClick?: (
    event: React.MouseEvent<HTMLImageElement>,
    imageRef: React.MutableRefObject<HTMLImageElement>
  ) => void;
  definedPoints?: Point[];
  removePoints?: Function;
};

export default function ResponseInput({
  placeHolder,
  styleClass,
  inputValue = "",
  handleInputChange,
  index,
  imageUrl,
  handleImageChange,
  imageWidth,
  imageHeight,
  hasFile,
  id,
  valueUpdated,
  tabIndex,
  children,
  questionInput,
  maxLength,
  questionDirection,
  setSentence,
  hasAudio,
  handleVoiceChange,
  inputVoice,
  onImageClick,
  definedPoints,
  removePoints,
}: ResponseInputProps) {
  const [stateValue, setStateValue] = useState<string>();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [focused, setFocused] = useState(false);
  const [crindex, setcrIndex] = useState<number>();
  useEffect(() => {
    setStateValue(inputValue);
    setcrIndex(index);
    if (stateValue === undefined) {
    }
  }, [inputValue]);

  useEffect(() => {
    if (stateValue !== inputValue && valueUpdated && focused) {
      const delayDebounceFn = setTimeout(() => {
        if (stateValue !== inputValue && valueUpdated && focused) {
          valueUpdated!(stateValue, crindex);
        }
      }, 4000);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [stateValue, focused]);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileChange = (image: any, idx?: number) => {
    console.log(index);
    console.log(idx);
    if (handleImageChange) handleImageChange(image, crindex);
  };
  const handleAudioChange = (audio: any) => {
    if (handleVoiceChange) handleVoiceChange(audio, crindex);
  };
  const handleStateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputElement = e.target as HTMLInputElement;
    if (setSentence) setSentence(e.target.value);
    if (valueUpdated) setStateValue(e.target.value);
  };
  const handleStateTextAreaChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const inputElement = e.target as HTMLTextAreaElement;
    if (setSentence) setSentence(e.target.value);
    if (valueUpdated) setStateValue(e.target.value);
  };

  return (
    <div className={`flex text-lg w-full ${styleClass} relative`}>
      {!imageUrl ? (
        <Input
          key={id + ""}
          title={""}
          placeholder={placeHolder}
          styleClass={` inset-y-0 ${styleClass} w-full place-holder-p`}
          includeIcon={true}
          handleInput={handleStateChange}
          value={stateValue}
          onBlur={() => {
            setFocused(false);
            if (valueUpdated && inputValue !== stateValue) {
              valueUpdated!(stateValue, crindex);
            }
          }}
          onFocus={() => setFocused(true)}
          tabIndex={tabIndex}
          maxLength={maxLength}
          textareaRow={2}
          handleTextArea={handleStateTextAreaChange}
        >
          {imageUrl && (
            <div className="absolute flex items-center justify-end inset-y-0 inset-x-0 right-0 p-3">
              <Image
                onError={(e) => console.error(e.target)}
                height={50}
                width={100}
                src={imageUrl}
                alt="quiz-image"
                className="border-classic rounded-xl"
              />
            </div>
          )}
        </Input>
      ) : stateValue &&
        stateValue.length !== 0 &&
        questionInput === undefined ? (
        <Input
          key={id + ""}
          placeholder={placeHolder}
          styleClass={`inset-y-0 ${styleClass}`}
          includeIcon={true}
          handleInput={handleInputChange}
          value={stateValue}
          tabIndex={tabIndex}
          maxLength={maxLength}
          textareaRow={2}
          handleTextArea={handleStateTextAreaChange}
        />
      ) : imageUrl && questionInput === undefined ? (
        <div className="bg-bg-white rounded-xl justify-center flex items-center p-3 w-full h-full">
          <ImageUploader
            editable={true}
            imageUrl={imageUrl}
            width={imageWidth ? imageWidth : "w-32"}
            height={imageHeight ? imageHeight : "h-32"}
            handler={(img) => handleFileChange(img, index)}
            uniqueId={id}
          />
        </div>
      ) : (
        imageUrl &&
        questionInput && (
          <div className="flex flex-col items-start gap-3 w-full">
            <Input
              key={id + ""}
              title={""}
              placeholder={placeHolder}
              styleClass={` inset-y-0 ${styleClass} w-full `}
              includeIcon={hasFile}
              tabIndex={tabIndex}
              handleInput={handleStateChange}
              value={stateValue}
              onBlur={() => {
                setFocused(false);
                if (valueUpdated && inputValue !== stateValue) {
                  valueUpdated!(stateValue, crindex);
                }
              }}
              onFocus={() => setFocused(true)}
              photoPadding={questionDirection === "ltr" ? "ps-48" : undefined}
              textareaRow={2}
              handleTextArea={handleStateTextAreaChange}
            >
              {hasFile && (
                <div className="absolute inset-y-0  flex p-3  justify-around items-center grow self-stretch rounded-xl ">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      if (handleFileChange)
                        handleFileChange(e.target?.files?.[0]);
                    }}
                    ref={fileInputRef}
                    key={id + ""}
                  />
                  {!imageUrl && (
                    <button
                      className="flex justify-end gap-[6px] grow h-6 w-6 rounded-full bg-bg-cards1 p-1 hover:bg-tertiary "
                      onClick={handleButtonClick}
                    >
                      {icons.imageUpload}
                    </button>
                  )}
                </div>
              )}
              {imageUrl && (
                <div className="absolute flex items-center justify-end left-0 top-0 p-3 ">
                  <ImageUploader
                    editable={true}
                    imageUrl={imageUrl}
                    width={imageWidth ? imageWidth : "w-40"}
                    height={imageHeight ? imageHeight : "h-40"}
                    handler={handleFileChange}
                    uniqueId={id}
                    onImageClick={onImageClick}
                    definedPoints={definedPoints}
                    removePoints={removePoints}
                  />
                </div>
              )}
            </Input>
          </div>
        )
      )}
      {hasFile && !imageUrl && (
        <div className="absolute left-1 bottom-1 flex  justify-around items-center grow self-stretch rounded-xl h-6 w-6">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              handleFileChange(e.target?.files?.[0]);
            }}
            ref={fileInputRef}
          />
          {((!stateValue && hasFile) || questionInput) && (
            <button
              className="flex justify-start gap-[6px] grow h-6 w-6 rounded-full text-gray-80  hover:bg-tertiary "
              onClick={handleButtonClick}
              tabIndex={-1}
            >
              {icons.imageUpload}
            </button>
          )}
        </div>
      )}
      {hasAudio && (
        <VoiceRecorder
          inputVoice={inputVoice ? ImageURL + inputVoice : undefined}
          onSave={(e) => {
            if (handleAudioChange) handleAudioChange(e);
          }}
        />
      )}
      {children}
    </div>
  );
}
